// extracted by mini-css-extract-plugin
export default {"fs":"dec398151c _16f9222b79"};